var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container", attrs: { id: "goods-edit" } },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: "" } },
            [
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div1" }, [_vm._v("商品管理")]),
              ]),
              _c(
                "el-breadcrumb-item",
                { attrs: { to: { path: "/goodsList" } } },
                [_c("div", { staticClass: "div1" }, [_vm._v("商品审核")])]
              ),
              _c("el-breadcrumb-item", [
                _c("div", { staticClass: "div2" }, [_vm._v("审核详情")]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._m(0),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("h3", [_vm._v("基础信息")]),
          _c(
            "el-form",
            {
              ref: "infoForm",
              staticClass: "info-form",
              attrs: {
                model: _vm.infoForm,
                rules: _vm.infoRules,
                "label-width": "100px",
              },
            },
            [
              _c("el-form-item", { attrs: { label: "申请平台" } }, [
                _c("div", [_vm._v(_vm._s(_vm.infoForm.platformName))]),
              ]),
              _c("el-form-item", { attrs: { label: "平台服务商" } }, [
                _vm._v(" " + _vm._s(_vm.infoForm.nickName) + " "),
              ]),
              _c("el-form-item", { attrs: { label: "联系电话" } }, [
                _vm._v(" " + _vm._s(_vm.infoForm.phone) + " "),
              ]),
              _c("el-form-item", { attrs: { label: "申请状态" } }, [
                _vm._v(" " + _vm._s(_vm.infoForm.goodsVerifyStatusLabel) + " "),
              ]),
              _c("el-form-item", { attrs: { label: "商品类型" } }, [
                _vm._v(" " + _vm._s(_vm.infoForm.goodsVerifyType) + " "),
              ]),
              _c("el-form-item", { attrs: { label: "商品类目" } }, [
                _vm._v(" " + _vm._s(_vm.categoryArrStr) + " "),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "商品名称", prop: "name" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "30%" },
                    model: {
                      value: _vm.infoForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.infoForm, "name", $$v)
                      },
                      expression: "infoForm.name",
                    },
                  }),
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "商品编号" } }, [
                _vm._v(" " + _vm._s(_vm.infoForm.goodsNo) + " "),
              ]),
              _c("el-form-item", { attrs: { label: "平台商品编号" } }, [
                _vm._v(_vm._s(_vm.infoForm.platformGoodsNo) + " "),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "content attr" }, [
        _c("div", { staticClass: "attr-title" }, [_vm._v("类目属性")]),
        _c(
          "div",
          { staticClass: "attr-content" },
          [
            _c("h4", [_vm._v("商品属性")]),
            _vm._l(_vm.goodsAttrData, function (item, index) {
              return [
                _c("h5", [_vm._v(_vm._s(item.name))]),
                _c(
                  "div",
                  { staticClass: "attr-list" },
                  [
                    _c("form-filed", {
                      ref: "formAttr" + item.id,
                      refInFor: true,
                      attrs: {
                        formconfig: item.formconfig,
                        formData: item.formData,
                      },
                      on: { formDataval: _vm.dialogClick },
                    }),
                  ],
                  1
                ),
              ]
            }),
          ],
          2
        ),
      ]),
      _c(
        "div",
        { staticClass: "content image-text-form" },
        [
          _vm._m(1),
          _c(
            "el-form",
            { attrs: { "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "运费设置" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "40%" },
                      on: { change: _vm.selectModel },
                      model: {
                        value: _vm.infoForm.freightTemplateId,
                        callback: function ($$v) {
                          _vm.$set(_vm.infoForm, "freightTemplateId", $$v)
                        },
                        expression: "infoForm.freightTemplateId",
                      },
                    },
                    _vm._l(_vm.models, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm.isShowTemplate
                ? _c(
                    "el-form-item",
                    { attrs: { label: "" } },
                    [
                      _vm.detail.calculType == 1
                        ? _c("number", {
                            attrs: {
                              isEdit: false,
                              tableData: _vm.tableData,
                              freight: _vm.detail.freight,
                              baseNumber: _vm.detail.baseNumber,
                              addNum: _vm.detail.addNum,
                              addPrice: _vm.detail.addPrice,
                            },
                          })
                        : _vm._e(),
                      _vm.detail.calculType == 2
                        ? _c("weight", {
                            attrs: {
                              isEdit: false,
                              tableData: _vm.tableData,
                              freight: _vm.detail.freight,
                              baseNumber: _vm.detail.baseNumber,
                              addNum: _vm.detail.addNum,
                              addPrice: _vm.detail.addPrice,
                            },
                          })
                        : _vm._e(),
                      _vm.tableDataF.length != 0
                        ? _c("free-delivery", {
                            staticStyle: { "margin-top": "10px" },
                            attrs: { tableData: _vm.tableDataF, isEdit: false },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content image-text-form" },
        [
          _c("h3", [_vm._v("图文信息")]),
          _c(
            "el-form",
            { attrs: { "label-width": "100px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商品图片(0/10)" } },
                [
                  _c("label", { attrs: { slot: "label" }, slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v("商品图片(" + _vm._s(_vm.fileList.length) + "/10)"),
                  ]),
                  _c("upload-picture", {
                    attrs: { limit: 10, list: _vm.fileList },
                    on: { changeImage: _vm.changeImage },
                  }),
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "" } }, [
                _vm._v(
                  " 图片尺寸：建议上传750px*750px，每张上传大小不得超过2M,支持jpg、png格式 "
                ),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "商品详情" } },
                [
                  _c("label", { attrs: { slot: "label" }, slot: "label" }, [
                    _c("span", { staticStyle: { color: "red" } }, [
                      _vm._v("*"),
                    ]),
                    _vm._v("商品详情"),
                  ]),
                  _c("quill-editor", {
                    ref: "myQuillEditor",
                    staticClass: "editor",
                    attrs: { options: _vm.editorOption },
                    model: {
                      value: _vm.infoForm.details,
                      callback: function ($$v) {
                        _vm.$set(_vm.infoForm, "details", $$v)
                      },
                      expression: "infoForm.details",
                    },
                  }),
                  _c(
                    "div",
                    { staticClass: "bottom", staticStyle: { display: "none" } },
                    [
                      _c("el-upload", {
                        ref: "uploadicon",
                        staticClass: "centerImg",
                        attrs: {
                          action: " ",
                          "list-type": "picture-card",
                          "auto-upload": false,
                          "on-change": _vm.handleAvatarChangeIcon,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "content", attrs: { id: "sku-content" } }, [
        _c("h3", [_vm._v("价格库存")]),
        _c("div", { staticClass: "sku-box" }, [
          _vm._m(2),
          _c("div", { staticClass: "sku-content-box" }, [
            _c(
              "div",
              { staticClass: "goods-sale" },
              [
                _vm.currentPageStatus === "add"
                  ? _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择",
                          multiple: "",
                          "collapse-tags": "",
                          "multiple-limit": 3,
                          disabled: _vm.currentPageStatus !== "add",
                        },
                        on: { change: _vm.onChangeGoodsSaleDataListValue },
                        model: {
                          value: _vm.goodsSaleDataListValue,
                          callback: function ($$v) {
                            _vm.goodsSaleDataListValue = $$v
                          },
                          expression: "goodsSaleDataListValue",
                        },
                      },
                      _vm._l(
                        _vm.skuFormConfig.sourceAttribute,
                        function (item) {
                          return _c("el-option", {
                            key: item.name,
                            attrs: { label: item.name, value: item.id },
                          })
                        }
                      ),
                      1
                    )
                  : _vm._e(),
                _vm.skuFormConfig.attribute.length < 3
                  ? [
                      !_vm.inputVisible && _vm.currentPageStatus === "add"
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                disabled:
                                  _vm.skuFormConfig.attribute.length > 2,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.showInput()
                                },
                              },
                            },
                            [_vm._v("添加规格")]
                          )
                        : _vm._e(),
                      _vm.inputVisible
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                disabled:
                                  _vm.skuFormConfig.attribute.length > 2,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.addSpecNameI()
                                },
                              },
                            },
                            [_vm._v("确认添加")]
                          )
                        : _vm._e(),
                    ]
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "choose-attribute" },
                  [
                    _vm._l(
                      _vm.skuFormConfig.attribute,
                      function (k, fatherIndex) {
                        return [
                          _c(
                            "h5",
                            [
                              _c("el-input", {
                                attrs: {
                                  size: "small",
                                  placeholder: "+ 自定义规格名称",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.changeInput()
                                  },
                                  blur: function ($event) {
                                    return _vm.changeAttributeTitle(
                                      k.name,
                                      fatherIndex
                                    )
                                  },
                                  focus: function ($event) {
                                    return _vm.changeAttributeTitleFocus(
                                      k.name,
                                      fatherIndex
                                    )
                                  },
                                },
                                model: {
                                  value: k.name,
                                  callback: function ($$v) {
                                    _vm.$set(k, "name", $$v)
                                  },
                                  expression: "k.name",
                                },
                              }),
                              _vm.currentPageStatus === "add"
                                ? _c("i", {
                                    staticClass: "el-icon-circle-close",
                                    on: {
                                      click: function ($event) {
                                        return _vm.onDeleteContent(
                                          fatherIndex,
                                          _vm.childrenIndex,
                                          "father"
                                        )
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _c("hr"),
                              _c("span", [_vm._v("规格值")]),
                              _c("span", [
                                _vm._v(
                                  "（已选 " + _vm._s(k.item.length) + "）"
                                ),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "choose-attribute-list" },
                            [
                              _vm._l(k.item, function (tag, childrenIndex) {
                                return [
                                  _vm.skuFormConfig.attribute[fatherIndex]
                                    .itemList[childrenIndex]
                                    ? [
                                        _vm.skuFormConfig.attribute[fatherIndex]
                                          .itemList[childrenIndex].content
                                          ? _c("el-input", {
                                              key: childrenIndex,
                                              attrs: { size: "small" },
                                              on: {
                                                input: function ($event) {
                                                  return _vm.changeInput()
                                                },
                                                change: function ($event) {
                                                  return _vm.onChangeContent(
                                                    fatherIndex,
                                                    childrenIndex
                                                  )
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.skuFormConfig.attribute[
                                                    fatherIndex
                                                  ].itemList[childrenIndex]
                                                    .content,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.skuFormConfig.attribute[
                                                      fatherIndex
                                                    ].itemList[childrenIndex],
                                                    "content",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "\n                        skuFormConfig.attribute[fatherIndex].itemList[\n                          childrenIndex\n                        ].content\n                      ",
                                              },
                                            })
                                          : _vm._e(),
                                        _vm.currentPageStatus === "add"
                                          ? _c("i", {
                                              staticClass:
                                                "el-icon-circle-close",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onDeleteContent(
                                                    fatherIndex,
                                                    childrenIndex
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ]
                                    : _vm._e(),
                                ]
                              }),
                            ],
                            2
                          ),
                        ]
                      }
                    ),
                    _vm.skuFormConfig.attribute.length < 3
                      ? [
                          _vm.inputVisible
                            ? _c(
                                "h5",
                                [
                                  _c("el-input", {
                                    attrs: {
                                      size: "small",
                                      placeholder: "+ 自定义规格名称",
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.changeInput()
                                      },
                                    },
                                    model: {
                                      value: _vm.specNameTemp.name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.specNameTemp, "name", $$v)
                                      },
                                      expression: "specNameTemp.name",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.inputVisible
                            ? _c(
                                "div",
                                { staticClass: "choose-attribute-list" },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      size: "small",
                                      placeholder: "+ 自定义规格值",
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.changeInput()
                                      },
                                    },
                                    model: {
                                      value: _vm.specNameTemp.item,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.specNameTemp, "item", $$v)
                                      },
                                      expression: "specNameTemp.item",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "goods-sale-list" },
              [
                _vm.skuFormConfig.attribute.length !== 0
                  ? _c("SkuForm", {
                      ref: "skuForm",
                      attrs: {
                        "source-attribute": _vm.skuFormConfig.sourceAttribute,
                        attribute: _vm.skuFormConfig.attribute,
                        sku: _vm.skuFormConfig.sku,
                        disabled: _vm.skuFormConfig.showForm,
                        structure: _vm.skuFormConfig.structure,
                      },
                      on: {
                        "update:attribute": function ($event) {
                          return _vm.$set(
                            _vm.skuFormConfig,
                            "attribute",
                            $event
                          )
                        },
                        "update:sku": function ($event) {
                          return _vm.$set(_vm.skuFormConfig, "sku", $event)
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "image",
                            fn: function (slotImg) {
                              return [
                                _c("mall-picture", {
                                  attrs: { imageUrl: slotImg.row.image },
                                  on: {
                                    getUrl: function ($event) {
                                      return _vm.getImage($event, slotImg)
                                    },
                                  },
                                }),
                              ]
                            },
                          },
                          {
                            key: "skuNo",
                            fn: function (slotSkuNo) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      slotSkuNo.row.skuNo
                                        ? slotSkuNo.row.skuNo
                                        : "- -"
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "status",
                            fn: function (slotProps) {
                              return [
                                _c("el-switch", {
                                  attrs: {
                                    "active-value": "1",
                                    "inactive-value": "0",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.onChangeSkuStatus(
                                        $event,
                                        slotProps.row
                                      )
                                    },
                                  },
                                  model: {
                                    value: slotProps.row.status,
                                    callback: function ($$v) {
                                      _vm.$set(slotProps.row, "status", $$v)
                                    },
                                    expression: "slotProps.row.status",
                                  },
                                }),
                              ]
                            },
                          },
                          {
                            key: "bindingSkuNo",
                            fn: function (slotBindingSkuNo) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.showDialogSkuVisible(
                                          $event,
                                          slotBindingSkuNo
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("手动绑定SKU")]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1496832652
                      ),
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
        _c(
          "div",
          [
            _c(
              "el-form",
              { attrs: { "label-width": "100px" } },
              [
                _vm.infoForm.goodsVerifyStatusLabel == "待审核"
                  ? _c("el-form-item", { attrs: { label: "审核操作" } }, [
                      _c("label", { attrs: { slot: "label" }, slot: "label" }, [
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("*"),
                        ]),
                        _vm._v("审核操作"),
                      ]),
                      _c(
                        "div",
                        [
                          _c(
                            "el-radio-group",
                            {
                              staticClass: "right",
                              model: {
                                value: _vm.infoForm.goodsVerifyStatus,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.infoForm,
                                    "goodsVerifyStatus",
                                    $$v
                                  )
                                },
                                expression: "infoForm.goodsVerifyStatus",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 3 } }, [
                                _vm._v("通过申请"),
                              ]),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("驳回申请"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.infoForm.goodsVerifyStatus == 3
                        ? _c("div", { staticClass: "remark" }, [
                            _vm.infoForm.otherPlatformUse == 1
                              ? _c("div", { staticClass: "remark-c" }, [
                                  _vm._v(" 选择上架平台 "),
                                ])
                              : _vm._e(),
                            _vm.infoForm.otherPlatformUse == 1
                              ? _c(
                                  "div",
                                  { staticStyle: { "margin-left": "10px" } },
                                  [
                                    _c(
                                      "el-checkbox",
                                      {
                                        attrs: {
                                          indeterminate: _vm.isIndeterminate,
                                        },
                                        on: {
                                          change: _vm.handleCheckAllChange,
                                        },
                                        model: {
                                          value: _vm.checkAll,
                                          callback: function ($$v) {
                                            _vm.checkAll = $$v
                                          },
                                          expression: "checkAll",
                                        },
                                      },
                                      [_vm._v("全选")]
                                    ),
                                    _c(
                                      "el-checkbox-group",
                                      {
                                        on: {
                                          change:
                                            _vm.handleCheckedplatformChange,
                                        },
                                        model: {
                                          value: _vm.infoForm.platformIds,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.infoForm,
                                              "platformIds",
                                              $$v
                                            )
                                          },
                                          expression: "infoForm.platformIds",
                                        },
                                      },
                                      _vm._l(_vm.platforms, function (item) {
                                        return _c(
                                          "el-checkbox",
                                          {
                                            key: item.platformId,
                                            staticStyle: { width: "44%" },
                                            attrs: { label: item.platformId },
                                          },
                                          [_vm._v(_vm._s(item.platformName))]
                                        )
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ])
                        : _vm._e(),
                      _vm.infoForm.goodsVerifyStatus == 2
                        ? _c(
                            "div",
                            { staticClass: "remarkB" },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { "margin-top": "10px" },
                                  attrs: {
                                    label: "备注",
                                    "label-width": "50px",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      placeholder: "请输入备注内容",
                                      rows: 6,
                                      maxlength: "200",
                                      "show-word-limit": "",
                                    },
                                    model: {
                                      value: _vm.infoForm.reason,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.infoForm, "reason", $$v)
                                      },
                                      expression: "infoForm.reason",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm.infoForm.goodsVerifyStatusLabel == "已通过"
                  ? _c("el-form-item", { attrs: { label: "上架平台" } }, [
                      _c(
                        "div",
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { indeterminate: _vm.isIndeterminate },
                              on: { change: _vm.handleCheckAllChange },
                              model: {
                                value: _vm.checkAll,
                                callback: function ($$v) {
                                  _vm.checkAll = $$v
                                },
                                expression: "checkAll",
                              },
                            },
                            [_vm._v("全选")]
                          ),
                          _c(
                            "el-checkbox-group",
                            {
                              on: { change: _vm.handleCheckedplatformChange },
                              model: {
                                value: _vm.infoForm.platformIds,
                                callback: function ($$v) {
                                  _vm.$set(_vm.infoForm, "platformIds", $$v)
                                },
                                expression: "infoForm.platformIds",
                              },
                            },
                            _vm._l(_vm.platforms, function (item) {
                              return _c(
                                "el-checkbox",
                                {
                                  key: item.platformId,
                                  staticStyle: { width: "44%" },
                                  attrs: { label: item.platformId },
                                },
                                [_vm._v(_vm._s(item.platformName))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm.infoForm.goodsVerifyStatusLabel == "已驳回"
                  ? _c("el-form-item", { attrs: { label: "驳回备注" } }, [
                      _vm._v(" " + _vm._s(_vm.infoForm.reason) + " "),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "content bottom-but" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "warning" },
              on: {
                click: function ($event) {
                  return _vm.toOtherPages("shopExamine")
                },
              },
            },
            [_vm._v("返回")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.verificationData } },
            [_vm._v("确认")]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialog.title,
            visible: _vm.dialog.visible,
            width: _vm.dialog.width,
            "append-to-body": true,
            "custom-class":
              _vm.dialog.type === "modifyState" ? "modify-state" : "",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          _vm.dialog.type === "modifyState"
            ? [
                _c("modify-state", {
                  attrs: { dialogInfo: _vm.dialog, list: _vm.giftListByGoodId },
                }),
                _c(
                  "div",
                  {
                    staticClass: "header-title",
                    attrs: { slot: "title" },
                    slot: "title",
                  },
                  [
                    _c("span", { staticClass: "icon" }, [
                      _c("i", { staticClass: "el-icon-warning" }),
                    ]),
                    _c("label", { staticClass: "name" }, [
                      _vm._v(_vm._s(_vm.dialog.title)),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "footer",
                    attrs: { slot: "footer" },
                    slot: "footer",
                  },
                  [
                    _c("el-button", { on: { click: _vm.centerModifyState } }, [
                      _vm._v("取 消"),
                    ]),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.submitModifyState },
                      },
                      [_vm._v("确 定")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "添加标签",
            visible: _vm.dialogVisible,
            "append-to-body": "",
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "loglabelbox" }, [
            _c(
              "div",
              { staticClass: "loglabeltopbox" },
              _vm._l(_vm.tagList, function (item, index) {
                return _c(
                  "div",
                  {
                    key: "dd" + item.id,
                    staticClass: "labelitem",
                    class: [item.select ? "selected" : "notselected"],
                    style: { cursor: item.select ? "not-allowed" : "pointer" },
                    on: {
                      click: function ($event) {
                        return _vm.selectTagFn(index)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(item.tagName) + " ")]
                )
              }),
              0
            ),
            _c("div", { staticClass: "circlebox" }, [
              _vm._v(" 已选 "),
              _c("div", { staticClass: "circle" }, [
                _vm._v(" " + _vm._s(_vm.seletedTag.length) + " "),
              ]),
            ]),
            _c(
              "div",
              {
                staticClass: "loglabeltopbox",
                staticStyle: { border: "none" },
              },
              _vm._l(_vm.seletedTag, function (item, index) {
                return _c(
                  "div",
                  { key: "dd" + item.id, staticClass: "labelitem labelitemc" },
                  [
                    _vm._v(" " + _vm._s(item.tagName) + " "),
                    _c("i", {
                      staticClass: "el-icon-circle-close labelicon",
                      on: {
                        click: function ($event) {
                          return _vm.deleteTag(index)
                        },
                      },
                    }),
                  ]
                )
              }),
              0
            ),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "绑定SKU",
            visible: _vm.dialogSkuVisible,
            "append-to-body": "",
            width: "32%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogSkuVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-left": "30px" } },
            [
              _vm._v(" SKU编码 "),
              _c("el-input", {
                staticStyle: { width: "400px", "margin-left": "15px" },
                attrs: { placeholder: "请输入所需绑定的SKU" },
                model: {
                  value: _vm.bindingSkuNo,
                  callback: function ($$v) {
                    _vm.bindingSkuNo = $$v
                  },
                  expression: "bindingSkuNo",
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticStyle: {
                "margin-left": "106px",
                color: "#f33f3f",
                "font-size": "12px",
              },
            },
            [_vm._v("请留意新旧商品规格是否一致")]
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogSkuVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.bindSku } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择标签",
            visible: _vm.showTagDialog,
            width: "1010px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showTagDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "tag—table-box" },
            [
              _c(
                "el-form",
                {
                  ref: "tagForm",
                  attrs: {
                    model: _vm.tagForm,
                    inline: true,
                    id: "search",
                    size: "small",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "标签", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: { clearable: "", placeholder: "标签名称" },
                        model: {
                          value: _vm.tagForm.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.tagForm, "name", $$v)
                          },
                          expression: "tagForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "类目", prop: "tagClass" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择类目", clearable: "" },
                          model: {
                            value: _vm.tagForm.tagClass,
                            callback: function ($$v) {
                              _vm.$set(_vm.tagForm, "tagClass", $$v)
                            },
                            expression: "tagForm.tagClass",
                          },
                        },
                        _vm._l(
                          _vm.dictionaries.goods_tag_class,
                          function (item) {
                            return _c("el-option", {
                              key: item.dictId,
                              attrs: {
                                label: item.dictName,
                                value: item.dictId,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c(
                      "div",
                      {
                        staticClass: "primary-mini",
                        on: {
                          click: function ($event) {
                            return _vm.fetchData()
                          },
                        },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "primary-mini",
                        on: {
                          click: function ($event) {
                            return _vm.fetchData("reset")
                          },
                        },
                      },
                      [_vm._v("重置")]
                    ),
                  ]),
                ],
                1
              ),
              _c("div", { staticStyle: { "margin-bottom": "20px" } }, [
                _c(
                  "div",
                  {
                    staticClass: "primary-plain",
                    on: {
                      click: function ($event) {
                        return _vm.batchSelectTag(1)
                      },
                    },
                  },
                  [_vm._v("批量选择")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "primary-plain",
                    on: {
                      click: function ($event) {
                        return _vm.batchSelectTag(2)
                      },
                    },
                  },
                  [_vm._v("批量取消")]
                ),
              ]),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.tagList,
                    "header-cell-style": {
                      background: "#F8F8F8",
                      color: "#333333",
                    },
                    "cell-style": { padding: "0" },
                  },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _c("el-table-column", { attrs: { type: "selection" } }),
                  _c("el-table-column", {
                    attrs: { label: "标签", prop: "tagName" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "排序", prop: "sort" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "标签分类", prop: "typeName" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "标签类目", prop: "className" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "是否对外展示", prop: "", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "p",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      scope.row.showFlag == 1 ? "是" : "否"
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "状态", prop: "tagName", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", { staticClass: "tag-status" }, [
                              _c("div", {
                                staticClass: "circle1",
                                style: {
                                  "background-color":
                                    scope.row.status == 1 ? "#67c23a" : "red",
                                },
                              }),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    scope.row.status == 1 ? "启用" : "停用"
                                  )
                                ),
                              ]),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作", prop: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            !scope.row.selected
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleSelectTag(scope)
                                      },
                                    },
                                  },
                                  [_vm._v("选择")]
                                )
                              : _vm._e(),
                            scope.row.selected
                              ? _c(
                                  "el-button",
                                  {
                                    staticStyle: { color: "red" },
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleSelectTag(scope)
                                      },
                                    },
                                  },
                                  [_vm._v("取消")]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    "margin-bottom": "20px",
                    "background-color": "#f8f8f8",
                    overflow: "hidden",
                  },
                },
                [
                  _c(
                    "div",
                    { staticStyle: { float: "right" } },
                    [
                      _vm.tagList.length > 0
                        ? _c("el-pagination", {
                            attrs: {
                              background: "",
                              "current-page": _vm.labelPageNo,
                              "page-sizes": [10, 20, 50],
                              "page-size": _vm.labelPageSize,
                              layout: "total, sizes, prev, pager, next, jumper",
                              total: _vm.labelTotalNum,
                            },
                            on: {
                              "size-change": _vm.onSizeChange,
                              "current-change": _vm.onCurrentChange,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "div",
                {
                  staticClass: "primary-gray",
                  on: {
                    click: function ($event) {
                      _vm.showTagDialog = false
                    },
                  },
                },
                [_vm._v("关 闭")]
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content page-title" }, [
      _c("h2", [_vm._v("商品详情")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h3", [
      _c("span", { staticStyle: { color: "#f33f3f" } }, [_vm._v("*")]),
      _vm._v("运费设置"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "sku-title" }, [
      _c("i", [_vm._v("*")]),
      _c("span", [_vm._v("商品规格")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }